export default __webpack_public_path__ + "static/media/filled-star.22c4d23b.svg";